export const categoryList = "CATEGORY_LIST";
